import { render, staticRenderFns } from "./marketing_insight.vue?vue&type=template&id=3ebbd906&scoped=true"
import script from "./marketing_insight.vue?vue&type=script&lang=js"
export * from "./marketing_insight.vue?vue&type=script&lang=js"
import style0 from "./marketing_insight.vue?vue&type=style&index=0&id=3ebbd906&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebbd906",
  null
  
)

export default component.exports